import request from '../utils/request';

// 分页查询发件人信息
export const getSenderInfoList = (params) => {
  return request({
    url: '/sender-info/page',
    method: 'get',
    params
  });
};

// 获取发件人信息详情
export const getSenderInfoDetail = (senderId) => {
  return request({
    url: `/sender-info/${senderId}`,
    method: 'get'
  });
};

// 创建发件人信息
export const createSenderInfo = (data) => {
  return request({
    url: '/sender-info',
    method: 'post',
    data
  });
};

// 更新发件人信息
export const updateSenderInfo = (id, data) => {
  return request({
    url: `/sender-info/${id}`,
    method: 'put',
    data
  });
};

// 删除发件人信息
export const deleteSenderInfo = (id) => {
  return request({
    url: `/sender-info/${id}`,
    method: 'delete'
  });
};
